import { motion } from "framer-motion";
import { Mail, Phone, MessageCircle, Instagram, Facebook, Youtube } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export const Footer = () => (
  <footer id="contact" data-testid="site-footer" className="border-t border-brand-border bg-brand-cream/40">
    <div className="mx-auto max-w-7xl px-6 py-24 lg:px-12 lg:py-32">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: EASE }}
        className="text-center"
      >
        <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-brand-gold">Begin a conversation</p>
        <h2 className="mx-auto mt-8 max-w-3xl font-display text-4xl font-medium leading-tight text-brand-ink md:text-6xl">
          Bring the sacred flame <em className="italic text-brand-maroon">to your home.</em>
        </h2>
        <p className="mx-auto mt-8 max-w-xl text-base font-light leading-relaxed text-brand-ink/70">
          For retail, wholesale or temple orders, call or write to us — we answer
          every enquiry with the same care we put into our craft.
        </p>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-5">
          <a
            href="https://wa.me/919205511502?text=Namaste%20Laxwedeepan%2C%20I%20would%20like%20to%20enquire%20about%20your%20products."
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-button"
            className="group inline-flex items-center gap-3 rounded-full bg-brand-peach px-10 py-5 text-[11px] font-medium uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-brand-maroon"
          >
            <MessageCircle className="h-4 w-4" strokeWidth={1.5} />
            WhatsApp Us
          </a>
          <a
            href="tel:+919205511502"
            data-testid="footer-call-button"
            className="group inline-flex items-center gap-3 rounded-full bg-brand-maroon px-10 py-5 text-[11px] font-medium uppercase tracking-[0.25em] text-brand-ivory transition-colors duration-300 hover:bg-brand-gold"
          >
            <Phone className="h-4 w-4" strokeWidth={1.5} />
            +91 92055 11502
          </a>
          <a
            href="mailto:namaste@laxwedeepan.com"
            data-testid="footer-enquire-button"
            className="inline-flex items-center gap-3 rounded-full border border-brand-ink/20 px-10 py-5 text-[13px] font-medium lowercase tracking-[0.12em] text-brand-ink transition-colors duration-300 hover:border-brand-gold hover:text-brand-maroon"
          >
            <Mail className="h-4 w-4" strokeWidth={1.5} />
            namaste@laxwedeepan.com
          </a>
        </div>
        <div className="mt-14 flex items-center justify-center gap-4" data-testid="footer-social-row">
          {[
            { icon: Instagram, label: "Instagram", testid: "social-instagram", href: "https://www.instagram.com/p/DehR7rnkuuA/?exln=MWs5OGxsOWFkYWFneQ==" },
            { icon: Facebook, label: "Facebook", testid: "social-facebook", href: "#contact" },
            { icon: Youtube, label: "YouTube", testid: "social-youtube", href: "#contact" },
          ].map((s) => (
            <a
              key={s.label}
              href={s.href}
              aria-label={`Laxwedeepan on ${s.label}`}
              data-testid={s.testid}
              className="flex h-11 w-11 items-center justify-center rounded-full border border-brand-gold/60 text-brand-maroon transition-colors duration-300 hover:bg-brand-gold hover:text-brand-ivory"
            >
              <s.icon className="h-4.5 w-4.5" strokeWidth={1.5} />
            </a>
          ))}
        </div>
      </motion.div>

      <div className="mt-24 flex flex-col items-center gap-8 border-t border-brand-border pt-12 md:flex-row md:justify-between">
        <a href="/" data-testid="footer-brand-link" className="flex items-center gap-2.5">
          <img src="/assets/nandi.png" alt="Nandi — the sacred cow of Laxwedeepan" className="h-9 w-auto" />
          <span className="font-display text-2xl tracking-wide text-brand-ink">laxwedeepan</span>
        </a>
        <p className="text-center text-[11px] uppercase tracking-[0.2em] text-brand-ink/50" data-testid="footer-certifications">
          GST 07AOMPP2034B3Z7 · TM 14867209 · FSSAI 23326002001289
        </p>
        <p className="text-[11px] uppercase tracking-[0.2em] text-brand-ink/50">
          Crafted with devotion in India
        </p>
      </div>
    </div>
  </footer>
);
